import React from 'react'

/* Styles */
import './Scoreboard.css'

/* Modules */
import { Button, Spin, Breadcrumb } from 'antd'
import { Link } from 'react-router-dom'
import TopBar from '../topBar/TopBar'

const ScoreboardView = (props) => {
	return (
		<div id='champContent'>

			<TopBar />
			<div style={{ height: '70px' }}></div>

			<div className="champsBlock">
				<Breadcrumb>
					<Breadcrumb.Item><Link to={'/home'}>Início</Link></Breadcrumb.Item>
					<Breadcrumb.Item>
						<Link to={{ pathname: '/home/champs', state: { userType: props.userType } }}>
							Campeonatos
						</Link>
					</Breadcrumb.Item>
					<Breadcrumb.Item>
						<Link to={{ pathname: '/home/champs/' + props.champId }}>
							{props.champObject.nome}
						</Link>
					</Breadcrumb.Item>
					<Breadcrumb.Item>
						{props.switchingOrRotation === 'rotation' ?
							<Link to={{ pathname: '/home/champs/' + props.champId + '/confrontation/rotation', state: { switchingId: props.idOfSwitching } }}>
								Rodízios
							</Link> :
							<Link to={{ pathname: '/home/champs/' + props.champId + '/confrontation/switching', state: { switchingId: props.idOfSwitching } }}>
								Chaves
							</Link>
						}
					</Breadcrumb.Item>
					<Breadcrumb.Item>Placar Eletrônico</Breadcrumb.Item>
				</Breadcrumb>
			</div>

			{props.loading ? <Spin style={{ width: '100%', marginTop: '50px' }} /> :
				<div>
					<div className='scoreboardTitle'>
						<p style={{ fontSize: 'xx-large' }}>Placar Eletrônico | Chave {props.chave} | {props.stage.charAt(0).toUpperCase() + props.stage.slice(1)}</p>
						<Button
							type='primary'
							onClick={props.saveScore}
							className='scoreboardTitleButton'
							loading={props.loadingSave}
						>Salvar</Button>

						<Button
							onClick={props.invertCompetitor}
							className='scoreboardTitleButton'
						>Inverter</Button>
					</div>


					<div className='scoreboardCompetitorParent'>
						<div className='scoreboardCompetitor01'>

							<div style={{ width: '70%', height: '100%', float: 'left' }}>
								<div className='scoreboardNameOfCompetitor'>
									{props.competitor01.isInverted ? <p style={{ color: 'yellow', fontSize: 'xx-large' }}>{props.competitor02.nome.substring(0, 35)}</p> : <p style={{ color: 'yellow', fontSize: 'xx-large' }}>{props.competitor01.nome.substring(0, 35)}</p>}
								</div>

								<div className='scoreboardNameAndPoint'>
									<div className='scoreboardNameOfHit'> Montada / Pegada <br /> nas costas </div>
									<div className='scoreboardIndividualScore'>
										{props.competitor01.isInverted ? props.competitor02.pontuacao['4'] * 4 : props.competitor01.pontuacao['4'] * 4}
									</div>
									<div style={{ width: '100%', height: '20%', textAlign: 'center' }}>
										<span className='scoreboardButton' onClick={() => props.scoreCompetitor(props.competitor01.isInverted ? 'competitor02' : 'competitor01', '4', 1)}> +4 </span>
										<span className='scoreboardButton' onClick={() => props.scoreCompetitor(props.competitor01.isInverted ? 'competitor02' : 'competitor01', '4', -1)}> -4 </span>
									</div>
								</div>

								<div className='scoreboardNameAndPoint'>
									<div className='scoreboardNameOfHit'> Passagem de <br /> guarda </div>
									<div className='scoreboardIndividualScore'>
										{props.competitor01.isInverted ? props.competitor02.pontuacao['3'] * 3 : props.competitor01.pontuacao['3'] * 3}
									</div>
									<div style={{ width: '100%', height: '20%', textAlign: 'center' }}>
										<span className='scoreboardButton' onClick={() => props.scoreCompetitor(props.competitor01.isInverted ? 'competitor02' : 'competitor01', '3', 1)}> +3 </span>
										<span className='scoreboardButton' onClick={() => props.scoreCompetitor(props.competitor01.isInverted ? 'competitor02' : 'competitor01', '3', -1)}> -3 </span>
									</div>
								</div>

								<div className='scoreboardNameAndPoint'>
									<div className='scoreboardNameOfHit'> Queda, Raspagem, <br /> Joelho na barriga </div>
									<div className='scoreboardIndividualScore'>
										{props.competitor01.isInverted ? props.competitor02.pontuacao['2'] * 2 : props.competitor01.pontuacao['2'] * 2}
									</div>
									<div style={{ width: '100%', height: '20%', textAlign: 'center' }}>
										<span className='scoreboardButton' onClick={() => props.scoreCompetitor(props.competitor01.isInverted ? 'competitor02' : 'competitor01', '2', 1)}> +2 </span>
										<span className='scoreboardButton' onClick={() => props.scoreCompetitor(props.competitor01.isInverted ? 'competitor02' : 'competitor01', '2', -1)}> -2 </span>
									</div>
								</div>

								<div className='scoreboardNameAndPoint02'>
									<div className='scoreboardNameOfAdvantageAndPunishment'> Vantagem </div>
									<div style={{ width: '100%', height: '65px', textAlign: 'center' }}>

										<div className='scoreboardIndividualScoreMini' style={{ backgroundColor: 'yellow', color: 'black', borderColor: 'yellow' }}>
											{props.competitor01.isInverted ? props.competitor02.pontuacao['1'] : props.competitor01.pontuacao['1']}
										</div>
										<div style={{ float: 'left', width: '15%', height: '65px' }}>
											<span className='scoreboardButtonMini' onClick={() => props.scoreCompetitor(props.competitor01.isInverted ? 'competitor02' : 'competitor01', '1', 1)}> + </span>
											<span className='scoreboardButtonMini' onClick={() => props.scoreCompetitor(props.competitor01.isInverted ? 'competitor02' : 'competitor01', '1', -1)}> - </span>
										</div>

									</div>

									<div className='scoreboardNameOfAdvantageAndPunishment'> Punições </div>
									<div style={{ width: '100%', height: '65px', textAlign: 'center', marginBottom: '10px' }}>

										<div className='scoreboardIndividualScoreMini' style={{ backgroundColor: 'red', color: 'white', borderColor: 'red' }}>
											{props.competitor01.isInverted ? props.competitor02.pontuacao['punicoes'] : props.competitor01.pontuacao['punicoes']}
										</div>
										<div style={{ float: 'left', width: '15%', height: '65px' }}>
											<span className='scoreboardButtonMini' onClick={() => props.scoreCompetitor(props.competitor01.isInverted ? 'competitor02' : 'competitor01', 'punicoes', 1)}> + </span>
											<span className='scoreboardButtonMini' onClick={() => props.scoreCompetitor(props.competitor01.isInverted ? 'competitor02' : 'competitor01', 'punicoes', -1)}> - </span>
										</div>
									</div>

									<div style={{ width: '100%', height: '30px', lineHeight: '30px' }}>
										{
											(props.competitor01.isInverted ?
												// <Checkbox
												// 	style={{ fontSize: 'smaller', color: 'yellow', textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden', width: '100%' }}
												// 	onChange={props.endConfrontationWinner02}
												// 	checked={props.competitor02.hasFinalized}
												// 	className='browser-default'
												// >Finalização</Checkbox> :
												// <Checkbox
												// 	style={{ fontSize: 'smaller', color: 'yellow', textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden', width: '100%' }}
												// 	onChange={props.endConfrontationWinner01}
												// 	checked={props.competitor01.hasFinalized}
												// 	className='browser-default'
												// >Finalização</Checkbox>
												<label>
													<input
														type="checkbox" className="filled-in"
														checked={props.competitor02.hasFinalized ? "checked" : null}
														onChange={props.endConfrontationWinner02}
													/>
													<span style={{ fontSize: 'smaller', color: 'yellow', textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden', width: '100%' }}>Finalização</span>
												</label> :
												<label>
													<input
														type="checkbox" className="filled-in"
														checked={props.competitor01.hasFinalized ? "checked" : null}
														onChange={props.endConfrontationWinner01}
													/>
													<span style={{ fontSize: 'smaller', color: 'yellow', textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden', width: '100%' }}>Finalização</span>
												</label>
											)
										}
									</div>
								</div>
							</div>

							<div style={{ width: '25%', height: '100%', float: 'left' }}>
								<div className='scoreboardNameOfTotalPoints' style={{ marginTop: '0px' }}>
									Pontuação Total
								</div>

								<div className='scoreboardTotalPoints'>
									{props.competitor01.isInverted ? props.competitor02.pontuacao['total'] : props.competitor01.pontuacao['total']}
								</div>
							</div>

						</div>

						<div className='scoreboardCompetitor02'>

							<div className='scoreboardCronBox'>
								<div style={{ marginLeft: '5px', marginRight: '5px', marginTop: '5px', height: '30px', textAlign: 'center' }}>
									Tempo restante
								</div>

								<div className='scoreboardCronBoxTimeAndFooter'>
									<div className='scoreboardCronBoxTimeAndFooterSub'>
										<span className='scoreboardButtonMini' onClick={props.plusCron}> + </span>
										<span className='scoreboardButtonMini' onClick={props.lessCron}> - </span>
									</div>
									<div className='scoreboardCronBoxTime'>
										{props.cronMin < 10 ? 0 : null}{props.cronMin}
										:
										{props.cronSeg < 10 ? 0 : null}{props.cronSeg}
									</div>
								</div>

								<div className='scoreboardCronBoxFooter'>
									<span style={{ cursor: 'pointer', marginRight: '30px' }} onClick={props.zeroCron}>Zerar</span>
									<span style={{ cursor: 'pointer' }} onClick={props.startStopCron}>Iniciar/Parar</span>
								</div>
							</div>

							<div style={{ width: '70%', height: '100%', float: 'left' }}>
								<div className='scoreboardNameOfCompetitor'>
									{props.competitor01.isInverted ? <p style={{ fontSize: 'xx-large' }}>{props.competitor01.nome.substring(0, 35)}</p> : <p style={{ fontSize: 'xx-large' }}>{props.competitor02.nome.substring(0, 35)}</p>}
								</div>

								<div className='scoreboardNameAndPoint'>
									<div className='scoreboardNameOfHit'> Montada / Pegada <br /> nas costas </div>
									<div className='scoreboardIndividualScore'>
										{props.competitor01.isInverted ? props.competitor01.pontuacao['4'] * 4 : props.competitor02.pontuacao['4'] * 4}
									</div>
									<div style={{ width: '100%', height: '20%', textAlign: 'center' }}>
										<span className='scoreboardButton' onClick={() => props.scoreCompetitor(props.competitor01.isInverted ? 'competitor01' : 'competitor02', '4', 1)}> +4 </span>
										<span className='scoreboardButton' onClick={() => props.scoreCompetitor(props.competitor01.isInverted ? 'competitor01' : 'competitor02', '4', -1)}> -4 </span>
									</div>
								</div>

								<div className='scoreboardNameAndPoint'>
									<div className='scoreboardNameOfHit'> Passagem de <br /> guarda </div>
									<div className='scoreboardIndividualScore'>
										{props.competitor01.isInverted ? props.competitor01.pontuacao['3'] * 3 : props.competitor02.pontuacao['3'] * 3}
									</div>
									<div style={{ width: '100%', height: '20%', textAlign: 'center' }}>
										<span className='scoreboardButton' onClick={() => props.scoreCompetitor(props.competitor01.isInverted ? 'competitor01' : 'competitor02', '3', 1)}> +3 </span>
										<span className='scoreboardButton' onClick={() => props.scoreCompetitor(props.competitor01.isInverted ? 'competitor01' : 'competitor02', '3', -1)}> -3 </span>
									</div>
								</div>

								<div className='scoreboardNameAndPoint'>
									<div className='scoreboardNameOfHit'> Queda, Raspagem, <br /> Joelho na barriga </div>
									<div className='scoreboardIndividualScore'>
										{props.competitor01.isInverted ? props.competitor01.pontuacao['2'] * 2 : props.competitor02.pontuacao['2'] * 2}
									</div>
									<div style={{ width: '100%', height: '20%', textAlign: 'center' }}>
										<span className='scoreboardButton' onClick={() => props.scoreCompetitor(props.competitor01.isInverted ? 'competitor01' : 'competitor02', '2', 1)}> +2 </span>
										<span className='scoreboardButton' onClick={() => props.scoreCompetitor(props.competitor01.isInverted ? 'competitor01' : 'competitor02', '2', -1)}> -2 </span>
									</div>
								</div>

								<div className='scoreboardNameAndPoint02'>
									<div style={{ width: '100%', height: '55%' }}>
										<div className='scoreboardNameOfAdvantageAndPunishment'> Vantagem </div>
										<div style={{ width: '100%', height: '65px', textAlign: 'center' }}>

											<div className='scoreboardIndividualScoreMini' style={{ backgroundColor: 'yellow', color: 'black', borderColor: 'yellow' }}>
												{props.competitor01.isInverted ? props.competitor01.pontuacao['1'] : props.competitor02.pontuacao['1']}
											</div>
											<div style={{ float: 'left', width: '15%', height: '65px' }}>
												<span className='scoreboardButtonMini' onClick={() => props.scoreCompetitor(props.competitor01.isInverted ? 'competitor01' : 'competitor02', '1', 1)}> + </span>
												<span className='scoreboardButtonMini' onClick={() => props.scoreCompetitor(props.competitor01.isInverted ? 'competitor01' : 'competitor02', '1', -1)}> - </span>
											</div>

										</div>

										<div className='scoreboardNameOfAdvantageAndPunishment'> Punições </div>
										<div style={{ width: '100%', height: '65px', textAlign: 'center' }}>

											<div className='scoreboardIndividualScoreMini' style={{ backgroundColor: 'red', color: 'white', borderColor: 'red', marginBottom: '10px' }}>
												{props.competitor01.isInverted ? props.competitor01.pontuacao['punicoes'] : props.competitor02.pontuacao['punicoes']}
											</div>
											<div style={{ float: 'left', width: '15%', height: '65px' }}>
												<span className='scoreboardButtonMini' onClick={() => props.scoreCompetitor(props.competitor01.isInverted ? 'competitor01' : 'competitor02', 'punicoes', 1)}> + </span>
												<span className='scoreboardButtonMini' onClick={() => props.scoreCompetitor(props.competitor01.isInverted ? 'competitor01' : 'competitor02', 'punicoes', -1)}> - </span>
											</div>
										</div>
									</div>
									<div style={{ width: '100%', height: '30px', lineHeight: '30px' }}>
										{
											(!props.competitor01.isInverted ?
												// <Checkbox
												// 	style={{ fontSize: 'smaller', textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden', width: '100%' }}
												// 	onChange={props.endConfrontationWinner02}
												// 	checked={props.competitor02.hasFinalized}
												// 	className='browser-default'
												// >Finalização</Checkbox> :
												// <Checkbox
												// 	style={{ fontSize: 'smaller', textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden', width: '100%' }}
												// 	onChange={props.endConfrontationWinner01}
												// 	checked={props.competitor01.hasFinalized}
												// 	className='browser-default'
												// >Finalização</Checkbox>
												<label>
													<input
														type="checkbox" className="filled-in"
														checked={props.competitor02.hasFinalized ? "checked" : null}
														onChange={props.endConfrontationWinner02}
													/>
													<span style={{ fontSize: 'smaller', textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden', width: '100%' }}>Finalização</span>
												</label> :
												<label>
													<input
														type="checkbox" className="filled-in"
														checked={props.competitor01.hasFinalized ? "checked" : null}
														onChange={props.endConfrontationWinner01}
													/>
													<span style={{ fontSize: 'smaller', textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden', width: '100%' }}>Finalização</span>
												</label>
											)
										}
									</div>
								</div>
							</div>

							<div style={{ width: '25%', height: '100%', float: 'left' }}>
								<div className='scoreboardNameOfTotalPoints'>
									Pontuação Total
								</div>

								<div className='scoreboardTotalPoints'>
									{props.competitor01.isInverted ? props.competitor01.pontuacao['total'] : props.competitor02.pontuacao['total']}
								</div>
							</div>

						</div>
					</div>
				</div>
			}
		</div>
	)
}

export default ScoreboardView